import React, { useState, useEffect } from "react";
import styles from "./UserProfile.module.css";

import { getUser, updateUserName, saveUser } from "../../utils/storage";
import MemoryChart from "../MemoryChart/MemoryChart";

const UserProfile = () => {
  const [name, setName] = useState("Usuário");
  const [inputName, setInputName] = useState("");
  const [editing, setEditing] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);

  const [scores, setScores] = useState({
    sequence: 0,
    visual: 0,
    delay: 0
  });

  const loadUser = () => {
    const user = getUser();

    setName(user.name || "Usuário");

    setScores({
      sequence: user.scores?.sequence || 0,
      visual: user.scores?.visual || 0,
      delay: user.scores?.delay || 0
    });
  };

  useEffect(() => {
    loadUser();

    window.addEventListener("ml_update", loadUser);

    return () => {
      window.removeEventListener("ml_update", loadUser);
    };
  }, []);

  const saveName = () => {
    if (!inputName.trim()) return;

    updateUserName(inputName);

    setInputName("");
    setEditing(false);
  };

  // 🔥 RESET
  const confirmReset = () => {
    const defaultUser = {
      name: name || "Usuário",
      scores: {
        sequence: 0,
        visual: 0,
        delay: 0
      },
      badges: [],
      history: []
    };

    saveUser(defaultUser);
    setShowConfirm(false);
  };

  const getAnalysis = () => {
    const { sequence, visual, delay } = scores;

    const max = Math.max(sequence, visual, delay);

    if (max === 0) {
      return "Complete os testes para descobrir seu perfil de memória.";
    }

    if (max === sequence) {
      return "Você tem uma forte memória sequencial. Seu cérebro trabalha bem com padrões lógicos.";
    }

    if (max === visual) {
      return "Sua memória visual é dominante. Você aprende melhor com imagens e padrões.";
    }

    return "Você possui ótima retenção de longo prazo.";
  };

  return (
    <div className={styles.container}>

      {/* HEADER */}
      <div className={styles.header}>
        <h3>👤 Perfil do Jogador</h3>

        <button
          className={styles.editButton}
          onClick={() => setEditing(!editing)}
        >
          {editing ? "Fechar" : "Editar Perfil"}
        </button>
      </div>

      {/* INFO */}
      <div className={styles.info}>
        <p className={styles.name}><strong>{name}</strong></p>

        <div className={styles.scoreGrid}>
          <div className={`${styles.scoreCard} ${styles.sequence}`}>
            🔢 <span>{scores.sequence}</span>
          </div>

          <div className={`${styles.scoreCard} ${styles.visual}`}>
            👁️ <span>{scores.visual}</span>
          </div>

          <div className={`${styles.scoreCard} ${styles.delay}`}>
            ⏱️ <span>{scores.delay}</span>
          </div>
        </div>
      </div>

      {/* EDIT */}
      {editing && (
        <div className={styles.edit}>
          <input
            className={styles.input}
            type="text"
            placeholder="Digite seu nome..."
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
          />

          <button className={styles.button} onClick={saveName}>
            Salvar
          </button>
        </div>
      )}

      {/* RESET */}
      {editing && (
        <div className={styles.resetBox}>
          <button
            className={styles.resetButton}
            onClick={() => setShowConfirm(true)}
          >
            Resetar Progresso
          </button>
        </div>
      )}

      {/* MODAL CONFIRMAÇÃO */}
      {showConfirm && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h4>⚠️ Confirmar reset</h4>
            <p>
              Tem certeza que deseja apagar todo seu progresso?
              Essa ação não pode ser desfeita.
            </p>

            <div className={styles.modalActions}>
              <button
                className={styles.buttonSecondary}
                onClick={() => setShowConfirm(false)}
              >
                Cancelar
              </button>

              <button
                className={styles.resetButton}
                onClick={confirmReset}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ANALYSIS */}
      <div className={styles.analysis}>
        <p>{getAnalysis()}</p>
      </div>

      <MemoryChart />
    </div>
  );
};

export default UserProfile;